// /src/api/fetchUnitsList.js
import axios from "axios";
import { ApiLink } from "../APILink/ApiLink";
import authHeader from "../Auth/authHeader";

export async function fetchUnitsList() {
  try {
    const response = await axios.get(ApiLink.API_URL + "articleunits", {
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("API fetchUnitsList error", error);
    throw error;
  }
}

export async function fetchPickUnit() {
  try {
    const response = await axios.get(ApiLink.API_URL + "ArticleUnits/pick", {
      headers: authHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("API fetchUnitsList error", error);
    throw error;
  }
}
